import { gql } from 'apollo-angular';

export var update_project_participants = gql`
  mutation UPDATE_PROJECT_PARTICIPANTS($input: UpdateParticipants!) {
    updateParticipants(input: $input){
      participants{
        id,
        role{
          id,
          name,
          roleType{
            name
          }
        },
        person{
          id, name,
          entity{
            entity_types{
              type{
                name,
                tagType{
                  name
                }
              }
            }
          }
        },
        organization{
          id, name,
          sponsor{
            id, name
          },
          entity{
            entity_types{
              type{
                name,
                tagType{
                  name
                }
              }
            }
          }
        }
        sponsor {
          id
          name
          is_repeat
        }
      }
    }
  }
`;
